import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AddVendorModal from "./AddVendorModal";

const AddVendor = ({ buttonLabel = "+ Add Vendor" }) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalProceed = (modalData) => {
    history.push({
      pathname: "/admin/vendor/create",
      search: `?vendorType=${encodeURIComponent(modalData?.vendorType?.value || "")}&vendorTypeLabel=${encodeURIComponent(modalData?.vendorType?.label || "")}&panCardNumber=${encodeURIComponent(modalData?.panCardNumber || "")}`,
    });
  };

  return (
    <>
      {/* ── Trigger button ── */}
      <AButton onClick={() => setModalOpen(true)} variant="primary_filled" size="xs">
        {buttonLabel}
      </AButton>

      {/* ── Modal ── */}
      <AddVendorModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onProceed={handleModalProceed}
      />
    </>
  );
};

export default AddVendor;
